// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    height: 8vh;
}

.header-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1200px;
    height: 100%;
    padding-inline: 20px;
    padding-block: 10px;
}

.header-content-admin {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding-inline: 20px;
    padding-block: 10px;
}


.logo-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.logo {
    height: 40px;
    cursor: pointer;
}

.header-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-signin {
    color: #000;
    padding-inline: 10px;
    padding-block: 8px;
    border-radius: 5px;
    font-size: 14px;
    font-family: "Gabarito", sans-serif;
}

.btn-signin:hover {
    background-color: #f0f0f0;
}

.btn-signup {
    color: #fff;
    background-color: #FF6600;
    padding-inline: 10px;
    padding-block: 8px;
    border-radius: 5px;
    font-size: 14px;
    font-family: "Gabarito", sans-serif;
}

.btn-signup:hover {
    background-color: #ff660080;
}

.btn-cancel{
    border : 1px solid #FF6600;;
    color: #FF6600;;
    padding-inline: 10px;
    padding-block: 8px;
    border-radius: 5px;
    font-size: 14px;
    font-family: "Gabarito", sans-serif;
}

.btn-cancel:hover {
    background-color: #ff660079;
}

.footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-top: 1px solid #f0f0f0;
    padding-block: 3vh;
    padding-top: 4vh;
}

.footer-content {
    display: flex;
    width: 100%;
    max-width: 1200px;
    padding-inline: 20px;
    padding-bottom: 15px;
    height: 100%;
    border-bottom: 1px solid #f0f0f0;
}

.footer-bottom {
    display: flex;
    width: 100%;
    max-width: 1200px;
    margin-top: 10px;
    padding-inline: 20px;
}

.social-icon-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 50%;
    background-color: #c388df;
    padding: 8px;
    color: white;
    cursor: pointer;
}

.social-icon-container:hover {
    background-color: #a72fcf;
}

.menu-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    cursor: pointer;
    padding-inline: 7px;
    padding-block: 9px;
}

.menu-item:hover {
    background-color: #f0f0f0;
    border-radius: 5px;
    cursor: pointer;
}

.menu-icon {
    width: 17px !important;
    height: auto;
}

.pro-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-radius: 5px;
}

.pro-btn {
    background-color: #FF6600;
    color: white;
    padding-inline: 10px;
    padding-block: 8px;
    border-radius: 5px;
    font-size: 12px;
    font-family: "Gabarito", sans-serif;
    cursor: pointer;
}

.pro-btn:hover {
    background-color: #758bf8;
}

/* Adicione este código ao seu arquivo CSS */
.spinning-logo-container {
    position: relative;
    width: 100px; /* Ajuste conforme necessário */
    height: 100px; /* Ajuste conforme necessário */
    display: flex;
    justify-content: center;
    align-items: center;
}

.menu-opt{
    color: #464646;
    padding-inline: 10px;
    padding-block: 8px;
    border-radius: 5px;
    font-size: 14px;
    font-family: "Gabarito", sans-serif;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.menu-opt.active {
    background-color: #FF6600;
    color: white;
}

.menu-opt:hover {
    background-color: #ff660044;
}

:where(.css-dev-only-do-not-override-ni1kz0).ant-steps .ant-steps-item-process .ant-steps-item-icon{
    background-color: #FF6600;
    border-color: #FF6600;
}

:where(.css-dev-only-do-not-override-ni1kz0).ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title::after{
    background-color: #FF6600;
}

:where(.css-dev-only-do-not-override-ni1kz0).ant-steps .ant-steps-item-finish .ant-steps-item-icon >.ant-steps-icon{
    color: #FF6600;
}`, "",{"version":3,"sources":["webpack://./src/Components/style/layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,YAAY,EAAE,+BAA+B;IAC7C,aAAa,EAAE,+BAA+B;IAC9C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mCAAmC;IACnC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".main-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    border-bottom: 1px solid #f0f0f0;\n    height: 8vh;\n}\n\n.header-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 1200px;\n    height: 100%;\n    padding-inline: 20px;\n    padding-block: 10px;\n}\n\n.header-content-admin {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n    padding-inline: 20px;\n    padding-block: 10px;\n}\n\n\n.logo-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.logo {\n    height: 40px;\n    cursor: pointer;\n}\n\n.header-actions {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-signin {\n    color: #000;\n    padding-inline: 10px;\n    padding-block: 8px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: \"Gabarito\", sans-serif;\n}\n\n.btn-signin:hover {\n    background-color: #f0f0f0;\n}\n\n.btn-signup {\n    color: #fff;\n    background-color: #FF6600;\n    padding-inline: 10px;\n    padding-block: 8px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: \"Gabarito\", sans-serif;\n}\n\n.btn-signup:hover {\n    background-color: #ff660080;\n}\n\n.btn-cancel{\n    border : 1px solid #FF6600;;\n    color: #FF6600;;\n    padding-inline: 10px;\n    padding-block: 8px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: \"Gabarito\", sans-serif;\n}\n\n.btn-cancel:hover {\n    background-color: #ff660079;\n}\n\n.footer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    border-top: 1px solid #f0f0f0;\n    padding-block: 3vh;\n    padding-top: 4vh;\n}\n\n.footer-content {\n    display: flex;\n    width: 100%;\n    max-width: 1200px;\n    padding-inline: 20px;\n    padding-bottom: 15px;\n    height: 100%;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.footer-bottom {\n    display: flex;\n    width: 100%;\n    max-width: 1200px;\n    margin-top: 10px;\n    padding-inline: 20px;\n}\n\n.social-icon-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    border-radius: 50%;\n    background-color: #c388df;\n    padding: 8px;\n    color: white;\n    cursor: pointer;\n}\n\n.social-icon-container:hover {\n    background-color: #a72fcf;\n}\n\n.menu-item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 5px;\n    cursor: pointer;\n    padding-inline: 7px;\n    padding-block: 9px;\n}\n\n.menu-item:hover {\n    background-color: #f0f0f0;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.menu-icon {\n    width: 17px !important;\n    height: auto;\n}\n\n.pro-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    border-radius: 5px;\n}\n\n.pro-btn {\n    background-color: #FF6600;\n    color: white;\n    padding-inline: 10px;\n    padding-block: 8px;\n    border-radius: 5px;\n    font-size: 12px;\n    font-family: \"Gabarito\", sans-serif;\n    cursor: pointer;\n}\n\n.pro-btn:hover {\n    background-color: #758bf8;\n}\n\n/* Adicione este código ao seu arquivo CSS */\n.spinning-logo-container {\n    position: relative;\n    width: 100px; /* Ajuste conforme necessário */\n    height: 100px; /* Ajuste conforme necessário */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.menu-opt{\n    color: #464646;\n    padding-inline: 10px;\n    padding-block: 8px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: \"Gabarito\", sans-serif;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n}\n\n.menu-opt.active {\n    background-color: #FF6600;\n    color: white;\n}\n\n.menu-opt:hover {\n    background-color: #ff660044;\n}\n\n:where(.css-dev-only-do-not-override-ni1kz0).ant-steps .ant-steps-item-process .ant-steps-item-icon{\n    background-color: #FF6600;\n    border-color: #FF6600;\n}\n\n:where(.css-dev-only-do-not-override-ni1kz0).ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-content>.ant-steps-item-title::after{\n    background-color: #FF6600;\n}\n\n:where(.css-dev-only-do-not-override-ni1kz0).ant-steps .ant-steps-item-finish .ant-steps-item-icon >.ant-steps-icon{\n    color: #FF6600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
